// shared/navigation-state.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { AtividadeService } from 'app/main/a2w/gestor/atividade/atividade.service';
import { FuseNavigationService } from './navigation.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationStateService {

    public navigation: any[] = [];
    public quantidade: number = 0;

    constructor(
        private _atividadeService: AtividadeService,
        private _authService: AuthenticationService,
        private _fuseNavigationService: FuseNavigationService,
        private route: Router,
    ) { }

    async buscaQtdAtividade(): Promise<any> {
        let vendId = this._authService?.currentUserValue?.userDetails?.vendedorId;
        if (vendId) {
            return await this._atividadeService.getQtdNotificacoes(vendId);
        }
        
    }
}
